import { useQuery } from '@tanstack/react-query';
import { getAgentDashboard, type GetAgentDashboardInput } from '@losan/core';
import { useSources } from '../contexts/SourcesContext.js';

export function useDashboard(input: GetAgentDashboardInput) {
  const sources = useSources();
  return useQuery({
    queryKey: [
      'dashboard',
      input.agentId,
      input.role ?? 'agent',
      input.viewAgentId ?? '',
      input.period,
      input.season ?? '__default__',
      input.filters?.line ?? '',
      input.filters?.category ?? '',
      input.reactivatedReds ?? 0,
    ],
    queryFn: () => getAgentDashboard(sources, input),
    staleTime: 60_000,
  });
}
